import { Tab, Tabs, Box } from "@material-ui/core";
import { ChangeEvent, useState } from "react";
import { Title, useAuthenticated } from "react-admin";
import { RouteComponentProps } from "react-router-dom";
import { ReportsGrid } from "./ReportsGrid";
import { ReportsArchive } from "./ReportsArchive";
import { useQueryParams } from "../../common/hooks/useQueryParams";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`reports-tabpanel-${index}`}
      aria-labelledby={`reports-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};

interface Props extends RouteComponentProps {}

export const Reports = (props: Props) => {
  useAuthenticated();

  const queryParams = useQueryParams();
  const [value, setValue] = useState(queryParams.get("tab") === "1" ? 1 : 0);

  const handleChange = (_: ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="content-container">
      <Title title="menu.reports" />
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Available reports" />
        <Tab label="Archive" />
      </Tabs>

      <TabPanel value={value} index={0}>
        <ReportsGrid {...props} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ReportsArchive />
      </TabPanel>
    </div>
  );
};
